import { useGetMember } from '#api/member';
import { sleepQualityToText } from '#utils/sleepQuality';
import {
  Container9,
  DefaultInfoText,
  DefaultInfoText2,
  RowDivider2
} from '../styles';
import NoAdvanceInfo from './NoAdvanceInfo';

// 사전 정보를 보여주는 함수
const AdvanceInfo = () => {
  const personId = sessionStorage.getItem('personId') ?? '';
  const { data: member } = useGetMember(personId);

  if (!member?.jobId) return <NoAdvanceInfo />;
  if (!member) return null;

  return (
    <Container9>
      <DefaultInfoText>키 · 몸무게</DefaultInfoText>
      <DefaultInfoText2>
        {member.healthInfo?.height || '-'}cm ·{' '}
        {member.healthInfo?.weight || '-'}kg
      </DefaultInfoText2>
      <RowDivider2 style={{ height: 1 }} />
      <DefaultInfoText>운동경력</DefaultInfoText>
      <DefaultInfoText2>
        {member.athleticExperience ? `${member.athleticExperience}년` : '-'}
      </DefaultInfoText2>
      <RowDivider2 style={{ height: 1 }} />
      <DefaultInfoText>PT 수강목적</DefaultInfoText>
      <DefaultInfoText2>
        {member.purposes?.map((item, idx) => (
          <div key={idx}>{item?.name ?? '-'}</div>
        ))}
      </DefaultInfoText2>
      <RowDivider2 style={{ height: 1 }} />
      <DefaultInfoText>수면정보</DefaultInfoText>
      <DefaultInfoText2>
        평균 수명의 질 :{' '}
        {sleepQualityToText(member?.healthInfo?.qualityOfSleep ?? '-')}
        <br />
        평균 수명 시간 : {member?.healthInfo?.sleepingHourAvg ?? '-'}
        시간
      </DefaultInfoText2>
      <RowDivider2 style={{ height: 1 }} />
      <DefaultInfoText>직업</DefaultInfoText>
      <DefaultInfoText2>
        {member?.jobName === '' ? '-' : member?.jobName}
      </DefaultInfoText2>
      <RowDivider2 style={{ height: 1 }} />
      <DefaultInfoText>병력</DefaultInfoText>
      <DefaultInfoText2>
        {member.healthInfo?.diseases?.map(diseases => diseases.kind.name) ||
          '없음'}
      </DefaultInfoText2>
      <RowDivider2 style={{ height: 1 }} />
      <DefaultInfoText>수술 이력</DefaultInfoText>
      <DefaultInfoText2>
        {member.healthInfo?.surgeryParts?.map(
          data => data.surgeryPartKind.name
        ) || '없음'}
      </DefaultInfoText2>
      <RowDivider2 style={{ height: 1 }} />
      <DefaultInfoText>통증 (부위/정도)</DefaultInfoText>
      <DefaultInfoText2>
        <div>
          {member.healthInfo?.painParts?.map((value, idx) => (
            <div key={idx}>
              - {value.kind.name} {value.level ? `/ ${value.level}` : ''}
            </div>
          )) || '없음'}
          {member.healthInfo?.painPartEtc && (
            <div>- {member.healthInfo.painPartEtc}</div>
          )}
        </div>
      </DefaultInfoText2>
      <RowDivider2 style={{ height: 1 }} />
      <DefaultInfoText>유입경로</DefaultInfoText>
      <DefaultInfoText2>기타 : 모름</DefaultInfoText2>
      <RowDivider2 style={{ height: 1 }} />
      <DefaultInfoText>추가 설명 및 문의사항</DefaultInfoText>
      <DefaultInfoText2>{member.etc ?? '-'}</DefaultInfoText2>
      <RowDivider2 style={{ height: 1 }} />
    </Container9>
  );
};

export default AdvanceInfo;
